import React, { useRef, useState } from 'react'
import { signin } from '../helpers/auth';
import Footer from './Sections/Footer'
import Header from './Sections/Header'

const SignInScreen = () => {

    const emailRef = useRef(null);
    const passwordRef = useRef(null);

    const [error, setError] = useState("");

    const handleLogin = async () => {
        if (emailRef.current.value.trim() && passwordRef.current.value.trim()) {
            try {
                const result = await signin(emailRef.current.value, passwordRef.current.value);
                if (!result.success) {
                    setError(result.error.message);
                }
            } catch (error) {
                console.log(error);
                setError(error.message);
            }
        } else {
            setError("Veuillez remplir tous les champs !");
        }
    }

    return (
        <div id="wrapper">
            {/* <Header /> */}
            <div uk-height-viewport="" className="uk-flex uk-flex-middle">
                <div className="uk-width-2-3@m uk-width-1-2@s m-auto rounded">
                    <div className="uk-child-width-1-2@m uk-grid-collapse bg-gradient-grey" uk-grid="">

                        <div className="uk-margin-auto-vertical uk-text-center uk-animation-scale-up p-3 uk-light">
                            <i className=" uil-graduation-hat icon-large"></i>
                            <h3 className="mb-4"> Leo Tech's Academy</h3>
                            <p>Le lieu où vous pouvez apprendre toute choses. </p>
                        </div>

                        <div className="uk-card-default p-5 rounded">
                            <div className="mb-4 uk-text-center">
                                <h3 className="mb-0"> Bienvenue !</h3>
                                <p className="my-2">Connectez-vous pour gérer votre compte.</p>
                            </div>
                            <form onSubmit={(e) => { e.preventDefault(); handleLogin() }}>
                                {error != "" && <div className="alert alert-danger">
                                    {error}
                                </div>}
                                <div className="uk-form-group">
                                    <label className="uk-form-label"> Email</label>

                                    <div className="uk-position-relative w-100">
                                        <span className="uk-form-icon">
                                            <i className="icon-feather-mail"></i>
                                        </span>
                                        <input ref={emailRef} className="uk-input" type="email" placeholder="name@example.com" />
                                    </div>

                                </div>

                                <div className="uk-form-group">
                                    <label className="uk-form-label"> Mot de passe</label>

                                    <div className="uk-position-relative w-100">
                                        <span className="uk-form-icon">
                                            <i className="icon-feather-lock"></i>
                                        </span>
                                        <input ref={passwordRef} className="uk-input" type="password" placeholder="********" />
                                    </div>

                                </div>

                                <div className="mt-4 uk-flex-middle uk-grid-small" uk-grid="">
                                    <div className="uk-width-expand@s">
                                        <p> Pas de compte? <a href="/inscription">Inscrivez-vous !</a></p>
                                    </div>
                                    <div className="uk-width-auto@s">
                                        <button type="submit" className="btn btn-default">Se connecter</button>
                                    </div>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    )
}

export default SignInScreen
